import { store } from '@/store/store';

export function GetCookieByName(str) {
    const name = str+'=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }

    return '';
}

// Physical cookie names are profile-prefixed (Std_ / Smart_) by the server. The SPA does no prefixing: the server
// resolves the active profile and publishes the fully-resolved physical names in the app-config cookie contract
// (store.state.cookieContract), which the domain helpers below read verbatim.
export function GetGrantPermissionRedirectCookie(): string[] {
    return GetCookieByName(store.state.cookieContract.grantPermissionRedirect).split(',');
}

export function GetAppRedirectPathCookie(): string[] {
    return GetCookieByName(store.state.cookieContract.appRedirectPath).split('%%');
}
